/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserRegisterDto } from '../../models/backend-user-register-dto';
import { BackendUserRegisterRequestDto } from '../../models/backend-user-register-request-dto';

export interface AccountRegisterCreate$XWwwFormUrlencoded$Params {
  body: BackendUserRegisterRequestDto;
}

export function accountRegisterCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: AccountRegisterCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserRegisterDto>> {
  const rb = new RequestBuilder(rootUrl, accountRegisterCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserRegisterDto>;
    }),
  );
}

accountRegisterCreate$XWwwFormUrlencoded.PATH = '/api/account/register/';
